import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-symptom-assessment-intro',
  standalone: true,
  imports: [CommonModule, TranslateModule, RouterLink],
  templateUrl: './symptom-assessment-intro.component.html',
  styleUrl: './symptom-assessment-intro.component.scss',
})
export class SymptomAssessmentIntroComponent {}
